import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SidebarStore {
  openedSidebar: boolean
  toggleSidebar: () => void
  setSidebarOpen: (open: boolean) => void

  openedMobile: boolean
  toggleMobile: () => void
  setMobileOpen: (open: boolean) => void
}

export const useSidebarStore = create<SidebarStore>()(
  persist(
    (set) => ({
      openedSidebar: true,
      toggleSidebar: () => set((state) => ({ openedSidebar: !state.openedSidebar })),
      setSidebarOpen: (open) => set({ openedSidebar: open }),

      openedMobile: false,
      toggleMobile: () => set((state) => ({ openedMobile: !state.openedMobile })),
      setMobileOpen: (open) => set({ openedMobile: open }),
    }),
    {
      name: 'sidebar-storage',
      partialize: (state) => ({
        openedSidebar: state.openedSidebar,
      }),
    },
  ),
)
